// Edit everything here to personalise the portfolio.
export const profile = {
  name: "Marco Escalante",
  role: "Multimedia & Learning Experience Designer",
  location: "Heathwood, QLD",
  email: "esc.marco6@gmail.com",
  phone: "0405665266",
  resumeUrl: "https://drive.google.com/file/d/156n0Qv2MY8Nr7_U2dLKoWZXqMSXjmk-d/view?usp=drive_link",
  linkedin: "www.linkedin.com/in/marcoescalante",
  availability: "Applying: Senior Project Officer, Queensland Virtual Academy",
};

export const heroLines = ["Turning curriculum", "into motion that", "students remember."];

export const marqueeWords = [
  "Visual storytelling",
  "Animations",
  "Cognitive load, reduced",
  "Accessible by design",
  "libraries",
  "Curriculum intent",
  "Concept to delivery",
];

export const reel = {
  // Paste a YouTube link here to use it instead of the mp4, e.g. "https://youtu.be/VIDEO_ID"
  youtube: "https://www.youtube.com/watch?v=7TzkuEGnUn4",
  src: "/media/reel-placeholder.mp4",
  poster: "/images/reel-poster.jpg",
  duration: "[01:30]",
  chapters: [
    { time: "00:00", title: "Mascot creating", tag: "converting existing 2d logos into mascots" },
    { time: "00:12", title: "3d Assets", tag: "Modeling and UV wrapping" },
    { time: "00:22", title: "Create worlds", tag: "Terrain and environments" },
    { time: "00:27", title: "Animation", tag: "Animate existing assets" },
  ],
};

// Paste a YouTube link into each `youtube` field. Leave `poster` empty to use the YouTube thumbnail.
export const animations = [
  {
    id: "anim-1",
    title: "SparkPop",
    subject: "Animation created to introduce their 3 mascots",
    summary: "Client requested the presentation to look similar to that of minecraft",
    youtube: "https://www.youtube.com/watch?v=rJ6nTYpKcdk",
    poster: "",
    duration: "[00:30]",
  },
  {
    id: "anim-2",
    title: "DESBT Cybersecurity",
    subject: "Presentation for Department of Small Business and Training",
    summary: "2d asset creation and animation",
    youtube: "https://www.youtube.com/watch?v=-y-h2Hjmqzw",
    poster: "",
    duration: "[03:55]",
  },
  {
    id: "anim-3",
    title: "C3 Systems",
    subject: "One of a series of visuals prepared for C3 systems",
    summary: "Assets were modeled individually and animated into a series of product presentations",
    youtube: "https://www.youtube.com/watch?v=-0vWo_MjI4g",
    poster: "",
    duration: "[00:44]",
  },
  {
    id: "anim-4",
    title: "NACAP",
    subject: "Presentation created to explain a joint operation of NACAP and SANTOS",
    summary: "A snippet of a longer presentation used by NACAP to present to SANTOS for their upcoming joint venture",
    youtube: "https://www.youtube.com/watch?v=NgRvRbKlnhw",
    poster: "",
    duration: "[00:42]",
  },
];

export const criteria = [
  {
    title: "Animation, motion graphics & visual communication",
    evidence: "I create clear, engaging visual content using animation, motion graphics and multimedia design to support communication and learning outcomes.",
    tags: ["2D animation", "3D animation", "Motion graphics", "Illustration", "3D modelling"],
  },
  {
    title: "Contemporary animation & digital design workflows",
    evidence: "I use current digital design tools and collaborative workflows to develop high-quality visual assets efficiently and consistently",
    tags: ["Adobe Suite", "Figma", "Blender", "Articulate360", "Moodle"],
  },
  {
    title: "Translating complex concepts into clear learning experiences",
    evidence: "I simplify complex information into accessible, learner-focused content that supports understanding and engagement.",
    tags: ["Visual explanation", "Storyboarding", "Infographics"],
  },
  {
    title: "Reusable design, templates & scalable creative assets",
    evidence: "I develop reusable templates, visual systems and scalable assets that improve consistency and streamline future content development.",
    tags: ["Templates", "libraries", "Brandkits", "Styleguides"],
  },
  {
    title: "Creative direction, design advice & innovative solutions",
    evidence: "I provide practical design advice, collaborate with stakeholders and apply creative thinking to deliver effective solutions.",
    tags: ["Creative direction", "Stakeholder engagement"],
  },
  {
    title: "Learning design principles & learner engagement",
    evidence: "I apply learning design principles to create interactive and engaging content that supports diverse learner needs and positive learning experiences.",
    tags: ["Principles of Design", "Inclusive design"],
  },
];

export const process = [
  { step: "Concept", text: "Unpack curriculum intent with teachers and writers." },
  { step: "Storyboard", text: "Sketch the visual argument. Test it for clarity before a single frame moves." },
  { step: "Design", text: "Build assets from the shared library so every subject feels like one family." },
  { step: "Animate", text: "Motion with purpose: guide the eye, pace the idea, style for impact." },
  { step: "Review", text: "Accessibility checks, captions, contrast and teacher feedback loops." },
  { step: "Deliver", text: "Versioned exports, tagged assets and handover notes for the next production." },
];

export const testimonials = [
  {
    quote: "Marco is the most genuine and loyal employee I have ever had the privilege of working with.",
    name: "Amanda Shepherd",
    title: "Managing Director, Green Fox Studio",
  },
  {
    quote: "Marco is reliable, hardworking and always willing to step up and help.",
    name: "Kelly Willmott",
    title: "Capture Manager, CAE Defence & Security",
  },
];

export const about = {
  bio: "I'm a multimedia creative designer with 9 years experience in the field. With two young daughters growing rapidly, I understand the value of education and it's delivery.  ",
  clients: [
    "Northrop Grumman", "C3 Systems", "Toll Aviation", "John Holland", "NACAP",
    "Quanta", "Climate Impact Corporation ", "Prestige Modular Buildings", "Cakum Global", "Geonadir",
    "Cystic Fibrosis QLD", "TedXBrisbane", "Queensland Futures Institute", "Sparkpop", "Social Traders",
  ],
  tools: ["After Effects", "Illustrator", "Figma", "Premiere Pro", "Blender", "Photoshop", "Indesign", "Articulate360"],
};
